export default __webpack_public_path__ + "static/media/Ab2.520073e1.mp3";